import * as React from 'react'
import styled from 'styled-components'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'
import * as services from '@owl-nest/services'

import { Comment } from './Comment'
import { CommentForm } from './CommentForm'

type CommentNodeProps = {
  className?: string
  queryReplies: (commentId: number) => void
  replyToComment: (commentId: number, payload: api.CreateComment) => void
} & (
  | {
      comment: services.comment.Comment<true>
      // FIXME; This is technically always true…
      isRoot: true
    }
  | {
      comment: services.comment.Comment
      isRoot: false
    }
)

export function CommentNode({
  className,
  comment,
  isRoot,
  queryReplies,
  replyToComment,
}: CommentNodeProps): React.ReactElement {
  const auth = services.user.useAuth()
  const [isFormOpen, setIsFormOpen] = React.useState(false)
  const hasMoreReplies = isRoot && comment.replies_meta !== null && comment.replies_count > comment.replies.length

  return (
    <Wrapper className={className}>
      <Comment
        comment={comment}
        onDelete={() => {
          // FIXME: implement?
        }}
        onReply={() => setIsFormOpen(true)}
      />
      {comment.replies?.length && (
        <ChildrenWrapper>
          {comment.replies.map((reply) => {
            return (
              <Comment
                comment={reply}
                onDelete={() => {
                  // FIXME: implement?
                }}
                onReply={() => setIsFormOpen(true)}
                key={reply.id}
              />
            )
          })}
          {hasMoreReplies && (
            <ViewMoreCTA onClick={() => queryReplies(comment.id)}>{t('View more replies')}</ViewMoreCTA>
          )}
        </ChildrenWrapper>
      )}
      {auth.type === 'loggedin' && isFormOpen && (
        <CommentForm
          /* eslint-disable-next-line jsx-a11y/no-autofocus */
          autoFocus={true}
          currentUser={auth.user}
          onCancel={() => setIsFormOpen(false)}
          onSubmit={async (values) => {
            replyToComment(comment.id, {
              comment: values.comment,
            })
            setIsFormOpen(false)
          }}
          submitLabel={t('Reply')}
        />
      )}
    </Wrapper>
  )
}

const ChildrenWrapper = styled.section`
  padding-left: 40px;
`

const ViewMoreCTA = styled(plume.LinkAsButton)`
  padding: 0;
  margin-bottom: 24px;
`

const Wrapper = styled.div`
  padding-top: 16px;
`
